import React from 'react'
import { styled } from 'styled-components'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { omit } from 'lodash'

const CustomFormSelect = styled(Select)`
  & input {
    cursor: pointer !important;
  }
`

const CustomSelect = (props) => {
  const cleanedProps = omit(props, 'entries')

  const options = props.entries.map(({ iso, name }) => ({ label: name, value: iso }))

  return (
    <CustomFormSelect
      {...cleanedProps}
      autoComplete="none"
      filterOption={(input, option) => (option?.label || '').toLowerCase().includes(input.toLowerCase())}
      options={options}
      showSearch
    />
  )
}

CustomSelect.propTypes = {
  entries: PropTypes.array.isRequired,
  onChange: PropTypes.func,
}

export default CustomSelect
